import { KuxProgramType } from '../interfaces';

import { KuXDms, MediaType } from './dms';
import { getEpgHoursPartial } from './epg-cache';
import { endPartOfDay } from './utils/date';

const NOT_FOUND_SIZE_MS = 3 * 60 * 60 * 1000;
const NOT_FOUND_MIN_SIZE_MS = 60 * 1000;

export const getNotFoundProgramType = (
  channelId: number,
  startDateNotFound: number,
  endDateNotFound: number,
): KuxProgramType => {
  return {
    adult: false,
    description: 'Not found',
    duration: 0,
    enableCatchUp: false,
    enableCdvr: false,
    enableStartOver: false,
    enableTrickPlay: false,
    endDate: endDateNotFound,
    epgId: '',
    linearAssetId: channelId,
    mediaType: MediaType.Program,
    metas: {},
    notFound: true, // TODO deprecated
    id: endDateNotFound + channelId * 10000,
    images: [],
    isNotFound: true,
    isPopular: false,
    parentalRating: 0,
    recordable: false,
    startDate: startDateNotFound,
    tags: {},
    title: 'notFoundProgram',
    type: Number(KuXDms.mediaTypes[MediaType.Program]),
    externalId: '',
    mosaicInfo: {
      isMosaicEvent: '0',
    },
    isGroupedSeries: false,
  } as KuxProgramType;
};

const getNotFoundArray = (startTime: number, endTime: number, channelId: number): KuxProgramType[] => {
  if (endTime - startTime < NOT_FOUND_MIN_SIZE_MS) {
    return [];
  }
  let startDateNotFound = startTime;
  let endDateNotFound = startTime;
  const notFoundArray: KuxProgramType[] = [];
  do {
    endDateNotFound = Math.min(endTime, endDateNotFound + NOT_FOUND_SIZE_MS);

    notFoundArray.push(getNotFoundProgramType(channelId, startDateNotFound, endDateNotFound));

    startDateNotFound = endDateNotFound;
  } while (startDateNotFound < endTime);
  return notFoundArray;
};

/**
 * Remove Overlap between programs
 *
 * @param programs: KuxProgramType[]
 */
const removeOverlap = (programs: KuxProgramType[]): KuxProgramType[] => {
  return programs.map((program, index) => {
    const nextProgram = programs[index + 1];
    if (!nextProgram) {
      return program;
    }
    if (program.endDate > nextProgram.startDate && program.id !== nextProgram.id) {
      program.endDate = nextProgram.startDate;
    }
    return program;
  });
};

export const coverUpProgramsDay = (
  programs: KuxProgramType[],
  channelId: number,
  startTime: number,
  yesterdayCache: KuxProgramType[],
  tomorrowCache: KuxProgramType[],
) => {
  const endTime = endPartOfDay(new Date(startTime), getEpgHoursPartial());
  const originPrograms = removeOverlap(programs);
  let startTimeFind = startTime;
  let endTimeFind = endTime;

  if (
    originPrograms[0] &&
    yesterdayCache[yesterdayCache.length - 1] &&
    originPrograms[0].id === yesterdayCache[yesterdayCache.length - 1].id
  ) {
    // Cached by previous day
    startTimeFind = originPrograms[0].endDate;
    originPrograms.shift();
  }

  if (
    originPrograms[originPrograms.length - 1] &&
    tomorrowCache[0] &&
    originPrograms[originPrograms.length - 1].id === tomorrowCache[0].id
  ) {
    // Cached by previous day
    endTimeFind = originPrograms[originPrograms.length - 1].startDate;
    originPrograms.unshift();
  }

  if (!originPrograms.length) {
    // If day is empty
    return getNotFoundArray(startTimeFind, endTimeFind, channelId);
  }

  let resultPrograms: KuxProgramType[] = [];
  originPrograms.forEach((program) => {
    resultPrograms = [...resultPrograms, ...getNotFoundArray(startTimeFind, program.startDate, channelId), program];
    startTimeFind = program.endDate;
  });

  if (startTimeFind < endTimeFind) {
    // Finish with notFound
    resultPrograms = [...resultPrograms, ...getNotFoundArray(startTimeFind, endTime, channelId)];
  }
  return resultPrograms;
};
